import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('errorNotification');

    return {
        TRY_AGAIN: t('tryAgain')
    };
};

export default useTranslation;
